import * as React from "react";
export const ChartGroup = React.lazy(() => import("./ChartGroupImpl"));
//# sourceMappingURL=ChartGroup.js.map